/** Admin UI + API: fixed course lengths (30 days = 1 month). */
export const COURSE_DURATION_OPTIONS = [
  { label: '15 days', days: 15 },
  { label: '1 month', days: 30 },
  { label: '2 months', days: 60 },
  { label: '3 months', days: 90 },
];

export function formatCourseDurationLabel(days) {
  const n = Number(days);
  const opt = COURSE_DURATION_OPTIONS.find((o) => o.days === n);
  return opt ? opt.label : `${n} days`;
}
